export default __webpack_public_path__ + "static/media/Symantec.f4b29906.png";